module.exports = __webpack_public_path__ + "img/LV4.00091948.webp";